export const assignType = (value: number | string): string | number => {
  if (!Number.isNaN(Number(value))) {
    value = Number(value);
  }
  return value;
};
